module.exports = __webpack_public_path__ + "assets/e591c5fe36e46e02dd35d6589a14c2ef.png";